import React from "react";
import { useMediaQuery } from "@mui/material";

const MetricsIcon = () => {
  const isMediumScreen = useMediaQuery("(max-width: 1100px)");
  const isTabletScreen = useMediaQuery("(max-width: 770px)");
  const isMobileScreen = useMediaQuery("(max-width: 420px)");

  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={
          isMediumScreen
            ? "30"
            : isTabletScreen
            ? "25"
            : isMobileScreen
            ? "40"
            : "50"
        }
        height="50"
        viewBox="0 0 50 50"
        style={{ fill: "#000000" }}
      >
        <g fill="#ffedc6">
          <path d="M7,8c-2.243,0 -4,1.757 -4,4v22c0,0.738 0.20506,1.413 0.53906,2h-2.53906c-0.552,0 -1,0.447 -1,1c0,2.757 2.243,5 5,5h40c2.757,0 5,-2.243 5,-5c0,-0.553 -0.448,-1 -1,-1h-2.53906c0.334,-0.587 0.53906,-1.262 0.53906,-2v-22c0,-2.243 -1.757,-4 -4,-4zM7,10h36c1.14,0 2,0.859 2,2v22c0,1.141 -0.86,2 -2,2h-36c-1.14,0 -2,-0.859 -2,-2v-22c0,-1.141 0.86,-2 2,-2zM35,15c-0.62986,0.00084 -1.22252,0.29835 -1.59951,0.80293c-0.37699,0.50458 -0.49427,1.15727 -0.3165,1.76152l-7.5625,7.50781c-0.16988,-0.04696 -0.34523,-0.07126 -0.52148,-0.07227c-0.1742,0.00088 -0.34755,0.02452 -0.51562,0.07031l-3.55273,-3.55273c0.1609,-0.60055 0.03335,-1.24177 -0.34511,-1.73504c-0.37846,-0.49327 -0.9648,-0.78247 -1.58653,-0.78254c-0.62094,0.00084 -1.20627,0.29004 -1.58419,0.78272c-0.37793,0.49268 -0.50558,1.13296 -0.34549,1.7329l-7.77734,7.77734c-0.26124,0.25082 -0.36647,0.62327 -0.27512,0.97371c0.09136,0.35044 0.36503,0.62411 0.71547,0.71547c0.35044,0.09136 0.72289,-0.01388 0.97371,-0.27512l(remaining path elements)..." />
        </g>
      </svg>
    </div>
  );
};

export default MetricsIcon;
